// extracted by mini-css-extract-plugin
export default {"root":"Attachments_root__QzACV","info":"Attachments_info__fTwHk"};